import React from 'react';
import { Box, Button, Chip, Grid, Paper, Stack, Typography } from '@mui/material';
import SportsTennisRoundedIcon from '@mui/icons-material/SportsTennisRounded';
import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';
import PendingRoundedIcon from '@mui/icons-material/PendingRounded';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../PageHeader';

const modes = [
  {
    key: 'MATCH_A_LA_MANIERE',
    title: 'Match “À la manière”',
    description: 'Entrée rapide pour lancer un match avec une interface pensée pour le terrain.',
    to: '/apps/badminton/match-a-la-maniere',
    available: true,
    tone: '#EEF7FF',
    icon: <SportsTennisRoundedIcon sx={{ fontSize: 34 }} />
  },
  {
    key: 'DEFI_BAD',
    title: 'Défi Bad',
    description: 'Préparer une classe, gérer les défis et enchaîner les matchs plus vite.',
    to: '/apps/badminton/defi/manage',
    available: true,
    tone: '#FFF4EA',
    icon: <EmojiEventsRoundedIcon sx={{ fontSize: 34 }} />
  },
  {
    key: 'MATCH_SIMPLE',
    title: 'Match simple',
    description: 'Mode prévu pour plus tard, conservé visible pour clarifier la feuille de route.',
    to: '/apps/badminton/match-simple',
    available: false,
    tone: '#F6F6F6',
    icon: <PendingRoundedIcon sx={{ fontSize: 34 }} />
  },
  {
    key: 'EXERCICES',
    title: 'Exercices',
    description: 'Futur espace d’exercices guidés, à intégrer dans un second temps.',
    to: '/apps/badminton/exercices',
    available: false,
    tone: '#F6F6F6',
    icon: <PendingRoundedIcon sx={{ fontSize: 34 }} />
  }
];

export default function BadmintonHome() {
  const navigate = useNavigate();

  return (
    <Box sx={{ px: { xs: 2, sm: 3 }, py: { xs: 3, sm: 4 }, maxWidth: 1100, mx: 'auto' }}>
      <PageHeader
        title="Badminton"
        subtitle="Une entrée plus visuelle pour démarrer rapidement le bon mode sur mobile ou tablette."
        backTo="/apps"
        homeTo="/"
      />

      <Grid container spacing={3}>
        {modes.map((mode) => (
          <Grid item xs={12} md={6} key={mode.key}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                height: '100%',
                borderRadius: 4,
                backgroundColor: mode.tone,
                border: '1px solid rgba(63,61,86,0.08)',
                display: 'flex',
                flexDirection: 'column',
                gap: 2
              }}
            >
              <Stack direction="row" spacing={1} alignItems="center" useFlexGap flexWrap="wrap">
                <Chip label={mode.available ? 'Disponible' : 'Bientôt'} color={mode.available ? 'primary' : 'default'} />
              </Stack>

              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: 3,
                  backgroundColor: 'rgba(255,255,255,0.72)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {mode.icon}
              </Box>

              <Box>
                <Typography variant="h6" sx={{ fontWeight: 800 }}>
                  {mode.title}
                </Typography>
                <Typography color="text.secondary">
                  {mode.description}
                </Typography>
              </Box>

              <Box sx={{ flexGrow: 1 }} />

              <Button
                variant={mode.available ? 'contained' : 'outlined'}
                size="large"
                disabled={!mode.available}
                onClick={() => navigate(mode.to)}
                sx={{ minHeight: 48, alignSelf: 'flex-start' }}
              >
                {mode.available ? 'Ouvrir ce mode' : 'Bientôt disponible'}
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
